import { render, staticRenderFns } from "./GeneralDashboard.vue?vue&type=template&id=79705422&scoped=true&"
import script from "./GeneralDashboard.vue?vue&type=script&lang=js&"
export * from "./GeneralDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79705422",
  null
  
)

export default component.exports